import { ref, type Ref } from 'vue';
import Swal from 'sweetalert2';

import { useCustomer } from '@/use/customer';

const gourmetNeedLoveInfo: Ref<any> = ref(null);
const redeliveryOrderId: Ref<string | null> = ref(null);
const savedCart: Ref<any> = ref(null);
const gourmetRegistrationStoreNames: Ref<string[]> = ref([]);

export const useGourmet = () => {
  const { customerInfo, isNeedToShowFirstDeliveryPopup, isShownFirstDeliveryPopup, setShownFirstDeliveryPopup } = useCustomer();

  const setGourmetNeedLoveInfo = (value: any) => {
    gourmetNeedLoveInfo.value = value;
  };

  const setRedeliveryOrderId = (orderId: string | null) => {
    redeliveryOrderId.value = orderId;
  };
  const showFirstDeliveryPopup = () => {
    if (!customerInfo.value?.id || isShownFirstDeliveryPopup.value || !isNeedToShowFirstDeliveryPopup.value) {
      return;
    }

    const htmlContent = `
      <ul style="text-align: left;">
        <li style="margin-bottom: 5px;">Please be sure to explain how the Gourmet service works (treat as a regs call)</li>
        <li style="margin-bottom: 5px;">Please offer to send menus</li>
        <li>Remind customer to not pay in cash for any of our services (only for tipping)</li>
      </ul>
    `;

    Swal.fire({
      title: 'First Time Customer',
      html: htmlContent,
      imageUrl: '/static/img/first_time_delivery.png',
      imageWidth: 200,
      imageHeight: 200,
      imageAlt: 'First Time Delivery',
    });

    setShownFirstDeliveryPopup(true);
  };

  const setSavedCart = (value: any) => {
    savedCart.value = value;
  };

  return {
    savedCart,
    gourmetNeedLoveInfo,
    redeliveryOrderId,
    gourmetRegistrationStoreNames,

    setGourmetNeedLoveInfo,
    setRedeliveryOrderId,
    showFirstDeliveryPopup,
    setSavedCart,
  };
};
